import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, openBlock, createElementBlock, normalizeClass, unref, createElementVNode, createVNode, withCtx, createTextVNode, renderSlot, createCommentVNode } from 'vue';
import { useStyleConfig } from '../abstract';
import { Button, Tabs, TabPane } from 'ant-design-vue';
import ColorEditor from './ColorEditor.js';
import SizeEditor from './SizeEditor.js';
import StyleEditor from './StyleEditor.js';
import './ThemePreview.js';
var _hoisted_1 = {
  class: ""
};
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'ThemeEditor',
  setup: function setup(__props) {
    var _useStyleConfig = useStyleConfig('theme-editor'),
      prefixCls = _useStyleConfig.prefixCls;
    return function (_ctx, _cache) {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(prefixCls))
      }, [createElementVNode("div", {
        class: normalizeClass("".concat(unref(prefixCls), "-header"))
      }, [createElementVNode("div", {
        class: normalizeClass("".concat(unref(prefixCls), "-header-title"))
      }, "主题编辑器", 2 /* CLASS */), createElementVNode("div", _hoisted_1, [createVNode(unref(Button), null, {
        default: withCtx(function () {
          return [createTextVNode("导出")];
        }),
        _: 1 /* STABLE */
      }), createVNode(unref(Button), {
        class: normalizeClass("".concat(unref(prefixCls), "-btn-save")),
        type: "primary"
      }, {
        default: withCtx(function () {
          return [createTextVNode("保存")];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"])])], 2 /* CLASS */), createElementVNode("div", {
        class: normalizeClass("".concat(unref(prefixCls), "-main"))
      }, [createElementVNode("div", {
        class: normalizeClass("".concat(unref(prefixCls), "-setting"))
      }, [createVNode(unref(Tabs), {
        class: normalizeClass("".concat(unref(prefixCls), "-setting-tabs"))
      }, {
        default: withCtx(function () {
          return [createVNode(unref(TabPane), {
            key: "color",
            tab: "颜色"
          }, {
            default: withCtx(function () {
              return [createVNode(ColorEditor)];
            }),
            _: 1 /* STABLE */
          }), createVNode(unref(TabPane), {
            key: "size",
            tab: "尺寸"
          }, {
            default: withCtx(function () {
              return [createVNode(SizeEditor)];
            }),
            _: 1 /* STABLE */
          }), createVNode(unref(TabPane), {
            key: "style",
            tab: "风格"
          }, {
            default: withCtx(function () {
              return [createVNode(StyleEditor)];
            }),
            _: 1 /* STABLE */
          }), renderSlot(_ctx.$slots, "default", {}, function () {
            return [createCommentVNode(" 可自定义扩展配置项 ")];
          })];
        }),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["class"])], 2 /* CLASS */), createCommentVNode("v-if", true)], 2 /* CLASS */)], 2 /* CLASS */);
    };
  }
});

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var ThemeEditor = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/theme-provider/ThemeEditor.js"]]);
export { ThemeEditor as default };